import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Section,
  Container,
  Title,
  Item,
  Question,
  Toggle,
  Answer,
  AnswerText,
} from './FAQ.styled';

interface FAQItem {
  question: string;
  answer: string;
}

export default function FAQ() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const items = t('faq.items', { returnObjects: true }) as FAQItem[];

  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <Section id="faq">
      <Container>
        <Title>{t('faq.title')}</Title>
        {items.map((item, index) => {
          const isOpen = openIndex === index;
          const answerId = `faq-answer-${index}`;
          return (
            <Item key={item.question}>
              <Question
                aria-expanded={isOpen}
                aria-controls={answerId}
                onClick={() => handleToggle(index)}
              >
                {item.question}
                <Toggle $open={isOpen} aria-hidden>+</Toggle>
              </Question>
              <Answer
                id={answerId}
                role="region"
                $open={isOpen}
              >
                <AnswerText>{item.answer}</AnswerText>
              </Answer>
            </Item>
          );
        })}
      </Container>
    </Section>
  );
}
